import axios from 'axios';
import { useEffect, useState } from 'react';
import { useAuth } from '../Context/AuthContext';
import useAxiosFetch from './useAxiosFetch';

const useStateProvince = () => {
    const { setallStateList,allStateList} = useAuth();
      // api api from global hook 

  const { axiosFetch} = useAxiosFetch();;
const [allProvinceList,setallProvinceList]=useState([])

useEffect(()=>{
    if(allStateList?.length ==0){
        axiosFetch({
            axiosInstance: axios,
            method: "GET",
            url: `/global/countries`,
          }).then((data)=>{
            setallStateList(data?.data)
          })
    }
  
},[allStateList])


const getProvinceFunc=(state_id)=> {
    axios
    .post("global/province",{state_id: state_id})
  .then((res) => {
    setallProvinceList(res?.data)
   
  })
}


return [allStateList,allProvinceList,getProvinceFunc];

}

export default useStateProvince